import React, { useEffect, useRef } from 'react';
import Text from '~components/atoms/Text';
import CustomSkeleton from '~components/atoms/Skeleton';

import { useAppSelector } from '~redux/hooks';
import { FundTypeEnum, SilverTypeEnum } from '~utils/enums';

import * as Styles from './_silverProductPricingTable.module.scss';

const SilverProductPricingTable = () => {
    const dashboardSilverProductPricing = useAppSelector(state => state.dashboard.dashboardSilverProductPricing);
    const loading = useAppSelector(state => state.dashboard.loadings.getDashboardSilverProductPricing);
    const error = useAppSelector(state => state.dashboard.errors.getDashboardSilverProductPricing);

    const tableHeader = [
        'Denomination',
        'Bank Sell (MYR) per gram',
        'Bank Buy (MYR) per gram',
    ];

    const silverProductPricing = dashboardSilverProductPricing.filter(product => product.fundType === FundTypeEnum.Conventional && (product.silverType === SilverTypeEnum.PaperSilver || product.silverType === SilverTypeEnum.PhysicalSilver));

    // Only true until the first fetch completes (success or error)
    const isInitialLoad = useRef(true);

    useEffect(() => {
        if (!loading) {
            isInitialLoad.current = false;
        }
    }, [loading]);

    const renderTableHeader = () => {
        return tableHeader.map((header, index) => {
            return (
                <th key={index}>
                    {header}
                </th>
            );
        });
    };

    const renderTableBody = () => {
        // Show skeleton only during the very first fetch, not on re-polls
        if (isInitialLoad.current && loading) {
            return (
                <tr>
                    <td colSpan={3}>
                        <CustomSkeleton height={40} />
                    </td>
                </tr>
            );
        }

        if (error) {
            return (
                <tr>
                    <td colSpan={3}>
                        <Text
                            label={error}
                            isError
                        />
                    </td>
                </tr>
            );
        }

        if (!silverProductPricing.length) {
            return (
                <tr>
                    <td colSpan={3}>
                        <Text
                            label='No data found'
                            isError
                        />
                    </td>
                </tr>
            );
        }
        return silverProductPricing.map((product, index) => {
            return (
                <tr key={index}>
                    <td>{product.productName}</td>
                    <td>{typeof product.sellPrice === 'number' ? (Math.round(product.sellPrice * 100) / 100).toFixed(2) : '-'}</td>
                    <td>{typeof product.buyPrice === 'number' ? (Math.round(product.buyPrice * 100) / 100).toFixed(2) : '-'}</td>
                </tr>
            );
        });
    };

    return (
        <div className={Styles.container}>
            <Text
                label='Precious Metal (Silver)'
                className={Styles.title}
                isBold
            />

            <table className={Styles['table-container']}>
                <thead>
                    <tr>
                        {renderTableHeader()}
                    </tr>
                </thead>
                <tbody>
                    <tr>
                        <td colSpan={3} />
                    </tr>
                    {renderTableBody()}
                </tbody>
            </table>
        </div>
    );
};

export default SilverProductPricingTable;
